import { PayerRequestAssignedNotification } from './PayerRequestAssignedNotification';

import { NewPayerRequestMessageNotification } from 'components/notifications/NewPayerRequestMessageNotification';
import { NewPayerRequestNotification } from 'components/notifications/NewPayerRequestNotification';
import { PayerRequestStatusChangedNotification } from 'components/notifications/PayerRequestStatusChangedNotification';

export const NotificationTypes = {
    PAYREQ_COMPASS: 'PAYREQ_COM',
    // Payer request assigned
    PAYREQASSIGN_COMPASS: 'PR_ASS_COM',
    // Payer request status updated:
    CR_IN_PROG: 'CR_IN_PROG',
    CR_APP_REQ: 'CR_APP_REQ',
    CR_APPROVE: 'CR_APPROVE',
    CR_APP_DEN: 'CR_APP_DEN',
    CR_RESOLVE: 'CR_RESOLVE',
    CR_CLOSED: 'CR_CLOSED',
    CR_CANCEL: 'CR_CANCEL',
    // Summary emails
    PAYREQSUM_COMPASS: 'PAYREQSUMC',
    // Payer request new message
    PR_MSG_COM: 'PR_MSG_COM',
} as const;

const StatusChangeNotificationTypes = [
    NotificationTypes.CR_IN_PROG,
    NotificationTypes.CR_APP_REQ,
    NotificationTypes.CR_APPROVE,
    NotificationTypes.CR_APP_DEN,
    NotificationTypes.CR_RESOLVE,
    NotificationTypes.CR_CLOSED,
    NotificationTypes.CR_CANCEL,
];

export const NotificationComponentMap = {
    [NotificationTypes.PAYREQ_COMPASS]: NewPayerRequestNotification,
    [NotificationTypes.PAYREQASSIGN_COMPASS]: PayerRequestAssignedNotification,
    [NotificationTypes.PR_MSG_COM]: NewPayerRequestMessageNotification,
    ...Object.fromEntries(
        StatusChangeNotificationTypes.map((type) => [type, PayerRequestStatusChangedNotification]),
    ),
} as const;
